module.exports = __webpack_public_path__ + "img/Skirt-Front-B10-Ca-Ha.0171f626.png";